(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = [...root.querySelectorAll('[data-dot]')];
    const stats = [...root.querySelectorAll('[data-stat]')];
    let index = 0;
    function show(next) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        dots[i].classList.toggle('swiper-pagination-bullet-active', i === index);
        dots[i].setAttribute('aria-current', String(i === index));
        stats[i].classList.toggle('active', i === index);
      });
    }
    root.querySelector('[data-prev]').addEventListener('click', () => show(index - 1));
    root.querySelector('[data-next]').addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    root.addEventListener('shopify:block:select', event => {
      const selected = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (selected >= 0) show(selected);
    });
    show(0);
  }
  function load(scope) {
    if (scope.matches && scope.matches('[data-before-after]')) init(scope);
    scope.querySelectorAll('[data-before-after]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => load(document), { once:true });
  else load(document);
  document.addEventListener('shopify:section:load', event => load(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-track]');
    const cards = [...root.querySelectorAll('[data-card]')];
    const pills = [...root.querySelectorAll('[data-pill]')];
    const dots = [...root.querySelectorAll('[data-dot]')];
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    let index = 0;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function update(value) {
      index = value;
      pills.forEach((pill,i) => { pill.classList.toggle('active',i===index); pill.setAttribute('aria-pressed',String(i===index)); });
      dots.forEach((dot,i) => { dot.classList.toggle('swiper-pagination-bullet-active',i===index); dot.setAttribute('aria-current',String(i===index)); });
      prev.disabled = index===0 || !cards.length;
      next.disabled = index>=cards.length-1;
      [prev,next].forEach(button => { button.classList.toggle('swiper-button-disabled',button.disabled); button.setAttribute('aria-disabled',String(button.disabled)); });
    }
    function go(value) {
      if (!cards.length) return;
      const target = Math.max(0,Math.min(value,cards.length-1));
      const rect = cards[target].getBoundingClientRect();
      track.scrollBy({left:rect.left-track.getBoundingClientRect().left,behavior:reduced.matches?'instant':'smooth'});
      update(target);
    }
    pills.forEach((pill,i) => pill.addEventListener('click',()=>go(i)));
    dots.forEach((dot,i) => dot.addEventListener('click',()=>go(i)));
    prev.addEventListener('click',()=>go(index-1));
    next.addEventListener('click',()=>go(index+1));
    track.addEventListener('scroll',()=>{
      const left=track.getBoundingClientRect().left;
      let nearest=0, distance=Infinity;
      cards.forEach((card,i)=>{ const delta=Math.abs(card.getBoundingClientRect().left-left); if(delta<distance){distance=delta;nearest=i;} });
      update(nearest);
    },{passive:true});
    root.addEventListener('shopify:block:select',event=>{
      const selected=cards.findIndex(card=>card.dataset.blockId===event.detail.blockId);
      if(selected>=0)go(selected);
    });
    update(0);
  }
  function load(scope) {
    if(scope.matches && scope.matches('[data-ingredients]'))init(scope);
    scope.querySelectorAll('[data-ingredients]').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>load(document),{once:true});
  else load(document);
  document.addEventListener('shopify:section:load',event=>load(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-timeline"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const steps = [...root.querySelectorAll('[data-step]')];
    const images = [...root.querySelectorAll('[data-step-image]')];
    function activate(step) {
      steps.forEach(other => { if (other !== step) other.open = false; });
      images.forEach(image => image.classList.toggle('active', image.dataset.stepImage === step.dataset.blockId));
    }
    steps.forEach(step => {
      step.querySelector('summary').addEventListener('click', event => {
        event.preventDefault();
        const open = !step.open;
        if (open) activate(step);
        step.open = open;
      });
      step.addEventListener('toggle', () => { if (step.open) activate(step); });
    });
    root.addEventListener('shopify:block:select', event => {
      const step = steps.find(item => item.dataset.blockId === event.detail.blockId);
      if (step) { activate(step); step.open = true; }
    });
  }
  function load(scope) {
    if (scope.matches && scope.matches('[data-editable-steps]')) init(scope);
    scope.querySelectorAll('[data-editable-steps]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => load(document), {once:true});
  else load(document);
  document.addEventListener('shopify:section:load', event => load(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
